<div [formGroup]="form" (keydown)="handleKeyDown($event)">
  <div class="container">
    <div class="header">
      <h4>{{ this.title }}</h4>
    </div>
    <div class="dialog-content">
      <p>{{ this.message }}</p>
      <div class="input" *ngIf="!this.error">
        <input-field-component
          label="Geburtsdatum"
          formControlName="birthday"
          placeHolder="TT.MM.JJJJ"
          (blurred)="this.form.get('birthday')?.markAsTouched()"
          [errorMessage]="
            this.errorHandler.getErrorMessage(this.form.get('birthday')?.errors)
          "
          [isError]="this.form.get('birthday')?.errors && this.form.get('birthday')?.touched"
          appGermanDate
        />
      </div>
    </div>
    <div class="actions">
      <theme-button
        *ngIf="!this.error"
        class="button"
        variation="filled"
        [disabled]="this.form.invalid"
        (click)="handleSubmit()"
        type="submit"
        isLoading="{{ this.isLoading }}"
      >
        Weiter
      </theme-button>

      <theme-button
        *ngIf="this.error"
        class="button"
        variation="filled"
        (click)="handleSubmit()"
        type="submit"
      >
        Zurück zur Startseite
      </theme-button>
    </div>
  </div>
</div>
